import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { BookingService } from '../../services/booking.service';
import { Component, Injector, OnInit } from '@angular/core';
import { DropdownOptionsService } from './../../../../core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';

@Component({
  selector: 'laas-booking-search-for-forwarder-header-detail',
  templateUrl: './booking-search-for-forwarder-header-detail.component.html',
  styleUrls: ['./booking-search-for-forwarder-header-detail.component.scss'],
})
export class BookingSearchForForwarderHeaderDetailComponent extends SessionBaseComponent implements OnInit {

  bookingModel: any;
  carrierPaymentTypeOptions: any[];
  deliveryTypeOptions: any[];
  deliverSubTypeOptions: any[];
  bookingTypeOptions: any[];
  chargeOptions: any[];
  forwarderOptions: any[];
  carTypeOptions: any[];
  carSeqOptions: any[];
  letterHeadOptions: any[];
  billCorpOptions: any[];
  pickupLocationOptions: any[];
  incoTermOptions: any[];
  bookingStatusOptions: any[];
  rfqAreaOptions: any[];
  facilityOptions: any[];
  payTypeOptions: any[];
  shipMethodOptions: any[];
  countryOptions: any[];
  cityOptions: any[];
  areaOptions: any[];
  isShowEditBtn: boolean;

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private dropdownOptionService: DropdownOptionsService,
    private facilityService: FacilityService
  ) {
    super(injector);

    this.bookingModel = null;
    this.forwarderOptions = [];
    this.carTypeOptions = [];
    this.carSeqOptions = [];
    this.letterHeadOptions = [];
    this.billCorpOptions = [];
    this.carrierPaymentTypeOptions = [];
    this.deliveryTypeOptions = [];
    this.deliverSubTypeOptions = [];
    this.bookingTypeOptions = [];
    this.chargeOptions = [];
    this.pickupLocationOptions = [];
    this.incoTermOptions = [];
    this.bookingStatusOptions = [];
    this.rfqAreaOptions = [];
    this.facilityOptions = [];
    this.payTypeOptions = [];
    this.shipMethodOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.areaOptions = [];
    this.isShowEditBtn = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getPayTypeOptions().subscribe({
      next: (options: any[]) => {
        this.payTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getCarrierPaymentTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carrierPaymentTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getBookingTypeOptions().subscribe({
      next: (options: any[]) => {
        this.bookingTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getCarTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getChargeOptions().subscribe({
      next: (options: any[]) => {
        this.chargeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
        console.log(this.deliveryTypeOptions);
      },
    });
    this.dropdownOptionService.getDeliverySubTypeOptions('O').subscribe({
      next: (options: any[]) => {
        this.deliverSubTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.incoTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map((x) => ({
          label: `${x.optionCode}-${x.optionDesc}`,
          value: x.optionCode,
        }));
      },
    });
    this.dropdownOptionService.getCountryOptions().subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map((x) => ({
          label: x.countryName,
          value: x.countryCode,
        }));
      },
    });
    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.cityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    this.dropdownOptionService.getAllAreaOptions().subscribe({
      next: (options: any[]) => {
        this.areaOptions = options.map((x) => ({
          label: x.rfqAreaName,
          value: x.rfqAreaCode,
        }));
      },
    });

    const bookingNo = this.routeStateService.getCurrent().data.bookingNo;
    this.bookingService.getBookingHeaderDetail(bookingNo).subscribe({
      next: (result) => {
        this.bookingModel = result;
        this.bookingModel.tmpCarSeq = this.bookingModel.carSeq?.slice(-4);

        this.isShowEditBtn = !['C'].includes(this.bookingModel.bookingStatus);

        if (this.bookingModel.deliveryType.indexOf('(') > -1) {
          this.bookingModel.deliveryType = this.bookingModel.deliveryType
            .substring(0, this.bookingModel.deliveryType.indexOf('('))
            .toUpperCase();
        } else {
          this.bookingModel.deliveryType = this.bookingModel.deliveryType.toUpperCase();
        }

        this.dropdownOptionService
          .getLetterOrgOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.billCorpOptions = options.map((x) => ({
                label: x.billOUName,
                value: x.billOUCode,
              }));
            },
          });
        this.dropdownOptionService
          .getForwarderOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.forwarderOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService
          .getPickupLocationOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.pickupLocationOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService
          .getCarSeqOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.carSeqOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode?.replace(':', ''),
              }));
            },
          });
        this.dropdownOptionService
          .getAreaOptions(this.bookingModel.facility)
          .subscribe({
            next: (options: any[]) => {
              this.rfqAreaOptions = options.map((x) => ({
                label: x.optionDesc,
                value: x.optionCode,
              }));
            },
          });
        this.dropdownOptionService.getFacilityOptions().subscribe({
          next: (options: any[]) => {
            this.facilityOptions = options.map((x) => ({
              label: x.optionDesc,
              value: x.optionCode,
            }));
          },
        });
      },
    });
  }

  editBtnClick(event: any): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/BookingSearchForForwarderHeaderEdit',
      this.bookingModel
    );
  }
}
